
import React from "react";
import { Breadcrumb, Button, Card, Col, Form, Input, Modal, Row, Select, Spin, Tag, Typography, message } from "antd";
import { Link } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb } from "../../services/hello-api";

class MapaGeralList extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _loading_button: false,
        _map: false,
        _map_data: [],
        _params: window.location.href.split('/'),
        item: null,
        modal: false,
        // TABLE
        table_data: [],
        table_search: '',
        table_pagination: {
            current: 1,
            total: 0,
            limit: 1000
        },
        table_sorter: null,
        table_select: [],
        table_filter: { INSTITUTION_ID: 'Selecione...' },
        value: '',
        filters: { INSTITUTION_ID: [], CLASS_STATUS_ID: [], RIVAL_ID: [] }
    }

    back = this.props.url;

    componentDidMount = () => {
        titleWeb('Mapa Geral')
        this.onFilters()
    }
    
    onFilters = () => {
        POST_API('/course/filters.php', { token: getToken() }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({filters: res.data})
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    // LOAD DATA
    onRenderData = () => {
        this.setState({_loading: true })
        var filter = this.state.table_filter;
        if (this.props.account) filter.ACCOUNT_ID = this.state._params[5]
        setTimeout(async () => {
            POST_API('/map/search.php', { token: getToken(), pagination: JSON.stringify(this.state.table_pagination), filter: JSON.stringify(filter), sorter: JSON.stringify(this.state.table_sorter), search: this.state.table_search, type: this.props.type }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({
                        table_data: res.data,
                        table_pagination: {
                            ...this.state.table_pagination,
                            total: res.summary.QTDE
                        }
                    })
                } else {
                    message.error({ content: res.msg, key: 'screen' })
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false }))
        }, 500);
    }

    onModal = (item) => {
        this.setState({item: item, modal: true})
    }

    onSend = (values) => {
        this.setState({_loading_button: true})
        POST_API('/class/save.php', { token: getToken(), type: 'edit', master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.onRenderData()
                this.setState({item: null, modal: false})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading_button: false}))
    }

    onChange = (v) => {
        POST_API('/class_status/search.php', { token: getToken(), filter: JSON.stringify({ID: v}), type: 'view' }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({item: { ...this.state.item, CLASS_STATUS_RIVAL: res.data.RIVAL } })
            } else {
                message.error({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }
    
    render = () => {

        const routes = this.props.bread
        
        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={18}>
                            <Breadcrumb items={routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.props.ret}><Button onClick={this.onChangePage} type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} style={{marginBottom: 10}} align={'bottom'}>
                        <Col xs={24} md={20}>
                            <Typography className="label_filter">Instituição</Typography>
                            <Select placeholder="Selecione..." style={{width: '100%'}} value={this.state.table_filter.INSTITUTION_ID} onChange={(v) => this.setState({table_filter: { ...this.state.table_filter, INSTITUTION_ID: v }})}>
                                { this.state.filters.INSTITUTION_ID.map( (v, i) => <Select.Option key={i} value={v.ID}>{v.NAME}</Select.Option> ) }
                            </Select>
                        </Col>
                        <Col xs={24} md={4}>
                            <Button shape="round" block type="primary" onClick={this.onRenderData}>Filtrar</Button>
                        </Col>
                    </Row>
                    { this.state._loading ? <Col span={24}><Row className="table__row_table" gutter={[8,8]} justify={'center'}><Spin /></Row></Col> : (
                        <>
                            { this.state.table_data.length > 0 ? (
                                <Col span={24}>
                                    <Row className="map_row" gutter={[8,8]}>
                                        { this.state.table_data.map((v, i) => (
                                            <Col xs={20} md={7} key={i}>
                                                <Card size="small" title={<Typography style={{textAlign: 'center'}}>{v.NAME}</Typography>}>
                                                    { v.CLASS.length > 0 ? (
                                                        <Row gutter={[16,16]}>
                                                            { v.CLASS.map((v1, i1) => (
                                                                <Col span={24} key={i1}>
                                                                    <Typography className="map_year">{v1.YEAR}</Typography>
                                                                    <Typography className="map_class">{v1.SEMESTER_NAME}</Typography>
                                                                    <Tag onClick={() => this.onModal(v1)} className="map_status" color={v1.CLASS_STATUS_COLOR}>{v1.CLASS_STATUS_NAME ? v1.CLASS_STATUS_NAME : 'Sem classificação'}</Tag>
                                                                </Col>
                                                            )) }
                                                        </Row>
                                                    ) : <Typography style={{textAlign: 'center'}}>Nenhuma turma encontrado</Typography> }
                                                </Card>
                                            </Col>
                                        )) }
                                    </Row>
                                </Col>
                            ) : <Col span={24}><Row className="table__row_table" gutter={[8,8]} justify={'center'}><Typography>Nenhum item encontrado</Typography></Row></Col> }
                        </>
                    )}
                </Col>
                <Modal width={300} destroyOnClose title={this.state.item?.ALL_CLASS} open={this.state.modal} onCancel={() => this.setState({modal: false, item: null})} footer={false}>
                    <Form layout="vertical" initialValues={this.state.item} onFinish={this.onSend}>
                        <Form.Item hidden name="ID">
                            <Input />
                        </Form.Item>
                        <Form.Item label="Situação" name="CLASS_STATUS_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                            <Select onChange={this.onChange}>
                                { this.state.filters.CLASS_STATUS_ID.map((a, b) => (
                                    <Select.Option key={b} value={a.ID} type={a.CLASS_STATUS_RIVAL}>{a.NAME}</Select.Option>
                                )) }
                            </Select>
                        </Form.Item>
                        { this.state.item?.CLASS_STATUS_RIVAL === 'S' ? (
                            <Form.Item label="Concorrência" name="RIVAL_ID" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                <Select>
                                    { this.state.filters.RIVAL_ID.map((a, b) => (
                                        <Select.Option key={b} value={a.ID}>{a.NAME}</Select.Option>
                                    )) }
                                </Select>
                            </Form.Item>
                        ) : null }
                        <Button loading={this.state._loading_button} htmlType="submit" type="primary" shape="round" block>Salvar</Button>
                    </Form>
                </Modal>
            </Row>
        )

    }

}

export default MapaGeralList;